<template>
    <div class="root" ref="root">
        <productImage :no="item.No" :mouseOverToggle="true"
            :tilbud="item.badgeTilbud" :spar="item.badgeSpar" />
        <div><h6><strong>{{item.Description}}</strong></h6></div>
        <div v-line-clamp:30="3" class="shortText">{{item.ShortText}}</div>
        <div class="text-right d-flex flex-column-reverse prices">
            <div v-if="twelvePrice">
                Pris ved 12 {{item.UoM}} <span class="highlight">{{twelvePrice.UnitPrice | price}} DKK</span><br>
                Løssalgspris {{item.UnitPrice | price}} DKK
            </div>
            <div v-else>
                <div v-if="oneDiscount"><del>Førpris: {{item.UnitPrice | price}} DKK</del> (Spar: {{(item.UnitPrice-oneDiscount.UnitPrice) | price}})</div>
                pr. {{item.UoM}} <span class="highlight">{{(oneDiscount && oneDiscount.UnitPrice || item.UnitPrice) | price}} DKK</span>
            </div>
        </div>
        <!-- <b-container> -->
        <b-row no-gutters class="mt-1" >
            <div v-if="item.Inventory<=item.InventoryRed" class="text-right">
                <b class="text-danger">Udsolgt</b>
                <showAlertWhenBackInStock v-if="isVine" :item="item" />
            </div>
            <div v-else class="d-flex w-100" @click.stop.prevent>
                <b-input-group class="flex-fill">
                    <b-form-input type="tel" v-model.number="count" class="px-2 text-center"></b-form-input>
                    <template v-slot:append>
                        <b-button variant="primary" class="px-1" @click="addToBasket(item)">Læg i kurven <svgicon icon="cart" width="24" height="24" color="#fff" class="d-none d-lg-inline"></svgicon></b-button>
                    </template>
                </b-input-group>
                <!-- <b-btn block variant="primary" class="flex-fill addToBasketBtn" @click="addToBasket(item)">Læg i kurven <svgicon icon="cart" width="24" height="24" color="#fff" class="d-sm-none d-lg-inline"></svgicon></b-btn> -->
                <!-- <b-col cols="6" class="pr-1"><b-button size="sm" variant="light" block class="customGreyButton text-uppercase">Se mere</b-button></b-col>
                <b-col cols="6" class="pl-1" v-if="item.type == 'Product'"><b-button size="sm" variant="primary" block @click.stop="addToBasket()" class="text-uppercase">Køb</b-button></b-col> -->
            </div>
        </b-row>
    </div>
</template>

<script>
import "../../icons/_rk/check-mark";
import "../../icons/cancel";
import "../../icons/cart";
import productImage from "./productImage.vue";
import showAlertWhenBackInStock from "./showAlertWhenBackInStock.vue";

var vineCategories = {
    10 : true, // rød
    11 : true, // hvid
    18 : true, // rose
    23 : true, // desert
    25 : true, // øko
    4848 : true // orange
}
export default {
    components: {
        productImage,
        showAlertWhenBackInStock
    },
    props: ["item"],
    computed:{
        oneDiscount(){
            return this.item && this.item.SalePrices && this.item.SalePrices.find(sp=>sp.MinQuantity == 0 || sp.MinQuantity == 1);
        },
        twelvePrice(){
            console.log(1);
            return this.item && this.item.SalePrices && this.item.SalePrices.find(sp=>sp.MinQuantity == 12);
        },
        isVine(){
            return this.item && this.item.Categories.find(itemCat=> vineCategories[itemCat.Id]);
        }
    },
    methods:{
        async addToBasket(){
            this.$root.$emit("showBuyMore", this.item.Url, this.count);
        },
    },
    data(){
        return {
            count : 1
        }
    },
    mounted(){
        (this.item && this.item.SalePrices || []).map(sp=>{
            if(sp.MinQuantity == 12)
                this.count = 12;
        })
    }
}
</script>
<style lang="scss" scoped>
    .root{
        /deep/{
            .count{
                width:150px;
                button{
                    border:1px solid #ced4da;
                    background-color: transparent;
                    color:black;
                    font-size:16px;
                    font-weight:bold;
                    padding:6px 8px;
                }
                input{
                    text-align:center;
                }
            }
            .smallGutters{
                margin:0 -8px;
                >div{
                    padding:0 8px;
                }
            }
        }
        color:black;
        button{
            font-weight: 500;
            font-size:13px;
            padding:5px 0 5px 0;
            // padding-bottom:5px;
            // padding-left:0;
            // padding-right:0;
            &.customGreyButton{
                background-color:#e2e6ea;
                border-color:#dae0e5;
                &:hover{
                    background-color: darken(#e2e6ea, 10%);
                    border-color:darken(#dae0e5, 10%);
                }
            }
        }
        .shortText{
            word-break:normal !important;
            line-height:20px;
            min-height: 60px;

            @media (max-width: 992px) {
                display: none !important;
            }
        }
        .prices{
            min-height:55px;
            .highlight{
                font-weight: 300;
                font-size: 18px;
            }
        }
        background-color: white;
        cursor: pointer;
        padding: 10px;
        // border:solid 2px red;
        &:hover{
            //  -webkit-transform: scale(1.06);
            // -moz-transform: scale(1.06);
            // -ms-transform: scale(1.06);
            // -o-transform: scale(1.06);
            // transform: scale(1.1);
            /*border: solid 2px #CDCDCD;*/
            // box-shadow: 0 0 5pt 3pt #aea399;
            // border-radius: 5px;
            // outline: solid 1px red;
            // background-color:#eeeeee80;
            // .modal-open &{
            //     transform: none;
            //     box-shadow: none;
            //     border-radius:0;
            // }

        }
    }
    .price
    {
        font-weight:bold;
        font-size: 1.75rem;
    }
</style>
